module.exports = __webpack_public_path__ + "static/img/3.5dc2cd3c.png";